import {
    InstanceComponent, InstanceOptions,
} from '../types'
import {DEFAULT_SCOPE} from '../Container'

import {PromiseModalContext} from '../PromiseModalContext'
import {
    useContext,
} from 'react'

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const usePromiseModal = <Resolve = any>(PromiseModal: InstanceComponent<any>, options?: InstanceOptions) => {
    const {promiseModalStack} = useContext(PromiseModalContext)

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const openPromiseModal = (props: any): Promise<Resolve> => {
        const ref = promiseModalStack[options?.scope || DEFAULT_SCOPE]
        return ref.create(PromiseModal, options, props)
    }

    return openPromiseModal
}
